import { useImpressionManager } from '@fiverr-private/impressionable';

/**
 * This is required to turn on BigQuery impressions from "inspire_listings" package.
 */
export const ImpressionableInitializer = () => {
  useImpressionManager();

  return null;
};
